import React from "react";
import { QuoteRequest } from "../../types/rate-analysis";

interface DateCalloutProps {
  quoteRequest: QuoteRequest;
  onRequestUpdate: () => void;
}

const DateCallout: React.FC<DateCalloutProps> = ({
  quoteRequest,
  onRequestUpdate,
}) => {
  // Get the most recent quote date, fallback to request creation date
  const getQuoteDate = () => {
    if (quoteRequest?.quotes?.length > 0) {
      const mostRecentQuote = quoteRequest.quotes.reduce((latest, current) =>
        new Date(current.created_at) > new Date(latest.created_at)
          ? current
          : latest
      );
      return mostRecentQuote.created_at;
    }
    return quoteRequest?.created_at || new Date();
  };

  return (
    <div className="flex justify-center mb-8">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 w-full max-w-2xl lg:max-w-3xl">
        <div className="flex items-start space-x-3">
          <div className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0">
            <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.008H12v-.008z"
              />
            </svg>
          </div>
          <div className="flex-1">
            <div className="text-sm text-blue-800">
              <p className="mb-3">
                Rate Estimates as of{" "}
                {new Date(getQuoteDate()).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                })}
                . Rates and pricing will fluctuate daily as the market changes.
              </p>
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                <button
                  onClick={onRequestUpdate}
                  className="text-sm text-blue-700 hover:text-blue-800 underline font-medium"
                >
                  Request updated rates
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateCallout;
